var indentStyle = {"indentZero":"rQtlz","indentOne":"M1rO8","indentTwo":"zRU9I","indentThree":"tVfw7","indentFour":"pJLbk","indentFive":"Yvbvr","indentSix":"hXl-6"};

export { indentStyle as i };
//# sourceMappingURL=indentation-761fcb0b.js.map
